import React, { useState } from "react";
import Table from "../../../../components/Table";
import TitleButtons from "../../../../components/TitleButtons";
import { generatePdfReport } from "../../../../utils/pdf/generatePdfReport";
import numeroParaExtenso from "../../../../utils/numeroPorExtenso";
import { useRetornosLaboratorio } from "./retornosData";

const LaboratorioEstoqueRetornos: React.FC = () => {
  const headers = [
    "Responsável Pelo Retorno",
    "PV/OS",
    "Posição",
    "Código",
    "Nome do Produto",
    "Quantidade",
    "Data",
    "Hora",
  ];

  const { rows, loading, refresh } = useRetornosLaboratorio();
  const columnWidths = [
    "150px",
    "60px",
    "10px",
    "10px",
    "300px",
    "60px",
    "70px",
    "10px",
  ];

  const [selectedColumns, setSelectedColumns] = useState<boolean[]>(
    headers.map(() => true)
  );

  const enabledColumnIndexes = selectedColumns
    .map((checked, i) => (checked ? i : -1))
    .filter((i) => i !== -1);

  const totalProdutos = rows.reduce(
    (acc, r) => acc + parseInt(r[5] as string),
    0
  );

  const valorTotal = rows.reduce((acc, r) => {
    const custo = parseFloat(
      (r[4] as string).replace(/[^\d,]/g, "").replace(",", ".")
    );
    const qtd = parseInt(r[5] as string);
    return acc + (isNaN(custo * qtd) ? 0 : custo * qtd);
  }, 0);

  return (
    <div>
      <TitleButtons
        title="Laboratório - Retornos no Estoque"
        buttons={[
          {
            label: "Gerar Relatório",
            onClick: () =>
              generatePdfReport({
                reportTitle: "Relatório de Estoque - Laboratório",
                fileNamePrefix: "Laboratorio-Estoque",
                subtitle: "Informações dos Produtos no Estoque",
                headers,
                rows,
                custoColIndex: 4,
                enabledColumns: enabledColumnIndexes,
                footerLines: [
                  `Total de Produtos no Estoque: ${totalProdutos}`,
                  `Valor Total em Estoque: R$ ${valorTotal.toLocaleString(
                    "pt-BR",
                    {
                      minimumFractionDigits: 2,
                    }
                  )} (${numeroParaExtenso(Math.floor(valorTotal))} reais)`,
                ],
              }),
            variant: "secondary",
            dropdownOptions: headers.map((h, i) => ({
              label: h,
              checked: selectedColumns[i],
            })),
            onOptionChange: (index, checked) => {
              const updated = [...selectedColumns];
              updated[index] = checked;
              setSelectedColumns(updated);
            },
          },
        ]}
      />
      <Table
        headers={headers}
        rows={rows}
        columnWidths={columnWidths}
        responsiveWidths={{
          1300: {
            1: "90px",
            2: "80px",
            3: "10px",
            4: "0px",
            5: "300px",
            6: "0px",
            7: "140px",
            8: "0px",
          },
        }}
      />
    </div>
  );
};

export default LaboratorioEstoqueRetornos;
